<template lang="slm">
  loader v-if="!article"
  article.Article(itemscope itemtype="http://schema.org/NewsArticle" role="article" v-else="")
    meta itemprop="mainEntityOfPage" :content="'https://rødungdom.no' + $route.path"
    meta itemprop="author" content="Rød Ungdom"
    div.is-hidden(itemscope itemprop="publisher" itemtype="http://schema.org/Organization")
      meta itemprop="name" content="Rød Ungdom"
      link itemprop="sameAs" href="http://rødungdom.no"
      div(itemprop="logo" itemscope itemtype="http://schema.org/ImageObject")
        meta itemprop="url" content="https://rødungdom.no/static/images/ru_logo.png"
        meta itemprop="width" content="120"
        meta itemprop="height" content="120"
      meta itemprop="thumbnailUrl" :content="article.thumbnail.asset.url + '?w=1200&h=630'" v-if="article.thumbnail"
    header
      section.Article-headerSection :class="{'is-page': article._type === 'page'}" style="position: relative;"
        .Article-headerImage ref="imageContainer" :style="setBackgroundImage"
          <!-- image-source v-if="width" :source="article.thumbnail.asset.url" :widths="widths" :ratio=3 :alt="text" :width="width" params="&blur=70&sat=-100" -->
        .container
          .column.is-8.is-offset-2.is-12-mobile
            .content
              h1 style="margin-top: 0; margin-bottom: 0;" itemprop="headline" {{article.title}}
      .container.Article-contentContainer
        .columns.is-multiline
          .column.is-9.is-offset-1.Article-metaContainer
            p.Article-metadata v-if="article._type.indexOf('article') > -1"
              | Publisert {{convertDate(article._createdAt)}}
              br.is-hidden-tablet
              span v-if="article._createdAt < article._updatedAt"
                span.is-hidden-mobile &nbsp;●&nbsp;
                | Sist oppdatert {{convertDate(article._updatedAt)}}
            meta v-if="article._createdAt < article._updatedAt" itemprop="dateModified" :content="convertDate(article._updatedAt)"
            meta itemprop="datePublished" :content="convertDate(article._createdAt)"
          .column.is-8.is-offset-2.is-7-widescreen v-if="article.lead"
            .content
              p.lead-in itemprop="description"  style="margin-bottom: 0" {{article.lead}}

    block-render :blocks="article.blocks.content" :textWrapClasses="classes" v-if="article.blocks"

    section
      .container
        .columns
          .column.is-7.is-offset-2
            .content
              .is-clearfix
                a.is-pulled-right.Button.is-outline.is-font-sans.Sharebutton :href="shareUrl"
                  |Del på Facebook

    section v-if="relatedIssues && relatedIssues.length > 0"
      .container
        .columns
          .column.is-7.is-offset-2
            .content
              h3 Les mer om hva vi mener om
              div.IssueList-item v-for="relatedIssue in relatedIssues"
                router-link :to="getSlug(relatedIssue)" {{relatedIssue.title}}
</template>

<script>
import BlockRender from '@/components/BlockRender'
import moment from 'moment'
import Loader from '@/components/Loader'
import ImageSource from '@/components/ImageSource'

moment.locale('nb')

export default {
  props: ['article'],
  data () {
    return {
      classes: 'column is-8 is-7-widescreen is-offset-2',
      title: this.article.title,
      relatedIssues: this.article.related_issues,
      widths: [530, 800, 1400],
      width: null
    }
  },
  mounted () {
    this.width = this.$refs.imageContainer.clientWidth
  },
  components: {
    'blockrender': BlockRender,
    Loader,
    ImageSource
  },
  beforeRouteEnter (to, from, next) {
  },
  methods: {
    convertDate (date) {
      return moment(date).format('Do MMMM YYYY H:mm')
    },
    getSlug (issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current
      } else {
        return issue.slug.current
      }
    }
  },
  computed: {
    shareUrl: function () {
      return `https://www.facebook.com/dialog/share?app_id=520751354930010&display=popup&href=https://rødungdom.no${this.$route.path}&redirect_uri=https://rødungdom.no${this.$route.path}`
    },
    setBackgroundImage: function () {
      if (this.article.thumbnail) {
        return {
          backgroundImage: 'url(' + this.article.thumbnail.asset.url + '?w=2000&q=60&blur=30)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        }
      } else {
        return null
      }
    }
  },
  metaInfo () {
    return {
      title: this.article.title + ' \u2014 Rød Ungdom', // set a title
      htmlAttrs: {
        lang: 'no',
        amp: undefined // "amp" has no value
      },
      meta: [
        {name: 'title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {name: 'description', content: this.article.lead},
        {name: 'twitter:title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {name: 'twitter:description', content: this.article.lead || 'Vi organiserer ungdom til kamp for en rettferdig verden.'},
        {name: 'twitter:image', content: `${this.article.thumbnail ? this.article.thumbnail.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'}`},
        {property: 'og:title', content: this.article.title + ' \u2014 Rød Ungdom'},
        {property: 'og:description', content: this.article.lead || 'Vi organiserer ungdom til kamp for en rettferdig verden.'},
        {property: 'og:image', content: `${this.article.thumbnail ? this.article.thumbnail.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'}`},
        {property: 'og:url', content: 'http://xn--rdungdom-54a.no' + this.$route.path}
      ]
    }
  }
}
</script>

<style lang="sass">
@import '../assets/stylesheets/_variables.sass'

.Article-contentContainer
  margin-top: -75px

.Article-metadata
  display: inline-block
  background-color: #fff
  padding: 8px 11px

.Article-metaContainer
  margin-bottom: 44px

.Article-headerSection
  &.is-page
    .Article-headerImage
      background-color: $blue
      &:before
        background-image: none

.Article-headerImage
  overflow: hidden
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 0
  background-color: $red

  background-blend-mode: multiply
  &:before
    content: ""
    display: block
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAHElEQVQYV2N8buL6X/LMbkYGKIAzMARgKjFUAABX9QgFhrBu7gAAAABJRU5ErkJggg==') repeat
    opacity: 1
    background-blend-mode: overlay

</style>



// WEBPACK FOOTER //
// src/components/NewsArticle.vue